<prism-select 
  [selectOptions]="options"
  [label]="label"
  placeHolder="Select a Role"
  [control]="control"
  [required]="required"
  [readOnly]="readOnly"
  [allowDeselect]="true"
  (onSelected)="emitRole($event)">
</prism-select>
